import { Grading } from '@mui/icons-material';
import { Badge, IconButton, Tooltip } from '@mui/material';

import { SMS } from 'domains/content/types';

type Props = {
    showAssessmentDialog: () => void;
    smsData?: SMS;
};

const AssessmentButton = ({ showAssessmentDialog, smsData }: Props) => (
    <Tooltip title="Select Assessment" placement="top">
        <span>
            <IconButton aria-label="Select Assessment" size="large" color="primary" onClick={showAssessmentDialog}>
                {smsData?.assessmentId && smsData.assessmentName ? (
                    <Badge color="success" variant="dot">
                        <Grading />
                    </Badge>
                ) : (
                    <Grading />
                )}
            </IconButton>
        </span>
    </Tooltip>
);

export default AssessmentButton;
